import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { X, Coins } from "lucide-react";

export default function BuyChipsModal({ open, onClose }) {
  const [packs, setPacks] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    if (!open) return;
    api.get("/chips/packs").then((r) => setPacks(r.data.packs));
  }, [open]);

  const buy = async (lookup_key) => {
    setBusy(lookup_key);
    try {
      const { data } = await api.post("/payments/checkout", {
        lookup_key,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Checkout failed");
      setBusy(null);
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose} data-testid="buy-modal">
      <div className="vexis-card w-full sm:max-w-2xl p-6 sm:p-8 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute right-4 top-4 text-slate-400 hover:text-white" data-testid="buy-close"><X className="w-5 h-5" /></button>
        <div className="pill pill-gold w-fit"><Coins className="w-3.5 h-3.5" /> Buy Chips</div>
        <h2 className="font-display text-2xl sm:text-3xl mt-3">Fuel your table</h2>
        <p className="text-sm text-slate-400 mt-2">Instant credit via Stripe. Secure checkout · test card 4242 4242 4242 4242.</p>

        <div className="grid sm:grid-cols-3 gap-3 mt-6">
          {packs.map((p) => (
            <button key={p.lookup_key} onClick={() => buy(p.lookup_key)} disabled={busy === p.lookup_key}
              data-testid={`pack-${p.lookup_key}`}
              className={`vexis-card vexis-card-hover p-5 text-left disabled:opacity-60 relative ${p.bonus_pct ? "ring-1 ring-[color:var(--gold)]/60" : ""}`}>
              {p.bonus_pct && (
                <span className="absolute -top-2 -right-2 pill pill-gold text-[10px]" data-testid={`promo-${p.lookup_key}`}>{p.promo_label}</span>
              )}
              <div className="text-xs font-mono uppercase tracking-widest text-slate-500" data-testid={`pack-label-${p.lookup_key}`}>{p.label}</div>
              <div className="mt-2 font-display text-3xl text-[color:var(--gold)]">
                {p.chips.toLocaleString()}
                {p.bonus_chips ? <span className="text-emerald-400 text-lg"> +{p.bonus_chips.toLocaleString()}</span> : null}
              </div>
              <div className="text-xs text-slate-400 mt-1">chips{p.bonus_chips ? ` · ${(p.chips + p.bonus_chips).toLocaleString()} total` : ""}</div>
              <div className="mt-4 flex items-center justify-between">
                <span className="font-mono text-slate-300">${p.usd}</span>
                <span className="text-xs text-slate-400">{busy === p.lookup_key ? "Redirecting…" : "Buy →"}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
